// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__l6kgA","socialIcon":"Footer_socialIcon__vuHZC"};